new Vue({
    el: '#app',
    components: {
        'IndustryList': httpVueLoader('../../assets/industry-list/industry.vue')
    }
});